import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LuHotel, LuUtensils, LuTrees, LuScissors } from "react-icons/lu";
import { FiChevronLeft, FiTrash2, FiUser } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { createPetPlace } from "../../redux/slices/petPlacesSlice";
import { MdOutlineArrowBackIos } from "react-icons/md";

const typeOptions = [
  { value: "hotels", label: "Hotel", icon: <LuHotel /> },
  { value: "restaurants", label: "Restaurant", icon: <LuUtensils /> },
  { value: "parks", label: "Park", icon: <LuTrees /> },
  { value: "services", label: "Service", icon: <LuScissors /> },
];

const fieldCls =
  "w-full rounded-md bg-gray-100 px-3.5 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/40";

export default function PetPlaceForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    type: "restaurants",
    phone: "",
    location: "",
    servicesProvided: "",
    timings: "",
    licensed: "Yes",
    price: "",
    address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createPetPlace(formData));
    navigate(-1);
  };

  return (
    <div className="mx-auto max-w-6xl px-6 py-8">
      {/* Header */}
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3">
          <button
                     onClick={() => navigate(-1)}
                     aria-label="Go Back"
                     className="mt-1 p-1 text-2xl text-gray-800 hover:text-blue-600"
                   >
                     <MdOutlineArrowBackIos />
                   </button>
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">
              Add New Pet Place
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              Add new pet place and so on
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            type="button"
            className="rounded-md p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
            title="Delete"
          >
            <FiTrash2 className="h-5 w-5" />
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            form="pet-place-form"
            type="submit"
            className="rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700"
          >
            Add Pet Place
          </button>
        </div>
      </div>

      {/* Section title */}
      <div className="mt-8 pb-4">
        <div className="flex items-center gap-2  font-medium text-gray-900">
          <FiUser className="h-4 w-4 text-gray-500" />
          Basic Information
        </div>
      </div>

      {/* Form */}
      <form
        id="pet-place-form"
        onSubmit={handleSubmit}
        className="mt-6 space-y-6"
      >
        {/* Row: Name / Type */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Enter Name
            </label>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="The Barking Bistro"
              className={fieldCls}
              required
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Select Places
            </label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className={`${fieldCls} pr-10`}
            >
              {typeOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Row: Phone / Location */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Phone Number
            </label>
            <input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+91 9876543210"
              className={fieldCls}
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Location
            </label>
            <input
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="India"
              className={fieldCls}
            />
          </div>
        </div>

        {/* Row: Services / Timings */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Services you Provide
            </label>
            <select
              name="servicesProvided"
              value={formData.servicesProvided}
              onChange={handleChange}
              className={fieldCls}
            >
              <option value="">Select Services</option>
              <option value="Grooming">Grooming</option>
              <option value="Pet Menu">Pet Menu</option>
              <option value="Dog Walking">Dog Walking</option>
              <option value="Vet On Call">Vet On Call</option>
            </select>
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Timings
            </label>
            <input
              name="timings"
              value={formData.timings}
              onChange={handleChange}
              placeholder="8 years"
              className={fieldCls}
            />
          </div>
        </div>

        {/* Row: Licensed / Price */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Licenced or Not
            </label>
            <select
              name="licensed"
              value={formData.licensed}
              onChange={handleChange}
              className={fieldCls}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Price
            </label>
            <input
              name="price"
              value={formData.price}
              onChange={handleChange}
              placeholder="Pending"
              className={fieldCls}
            />
          </div>
        </div>

        {/* Address (full width) */}
        <div>
          <label className="mb-2 block text-sm font-medium text-gray-700">
            Address
          </label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            rows={4}
            placeholder="Type Here"
            className={fieldCls}
          />
        </div>
      </form>
    </div>
  );
}
